module.exports = __webpack_public_path__ + "img/Maloba-Morgan.3b482100.jpg";